import { render, staticRenderFns } from "./Oxygen.vue?vue&type=template&id=5adce280&scoped=true&"
import script from "./Oxygen.vue?vue&type=script&lang=js&"
export * from "./Oxygen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adce280",
  null
  
)

export default component.exports